import { Tabs } from "antd";
import { AdminTabs} from "../../utils/constants";

const AdminPage = () => {
	return (
		<Tabs
			items={AdminTabs.map((item) => {
				return {
					key: item.name,
					label: (
						<span>
							{item.icon} {item.name}
						</span>
					),
					children: item.component,
				};
			})}
		/>
	);
};

export default AdminPage;
